export const sv = {
  roleOwner: 'Ägare',
  roleManager: 'Manager',
  roleMechanic: 'Mekaniker',
  colName: 'Namn',
  notProvided: 'Ej angivet',
  colRole: 'Roll',
  colStatus: 'Status',
  statusActive: 'Aktiv',
  statusInactive: 'Inaktiv',
  colAdded: 'Tillagd',
  heading: 'Personal',
  subtitle: 'Hantera personal och behörigheter',
  carCareTitle: 'Bilvårdskonto',
  carCareDescription: 'Personalhantering är inte tillgängligt för bilvårdskonton. Växla till en verkstad i sidomenyn för att hantera personal.',
  switchToGarage: 'Byt till verkstad',
  subtitleCarCare: 'Hantera bilvårdscentrets personal och behörigheter',
  subtitleGarage: 'Hantera verkstadens personal och behörigheter',
  invite: 'Bjud in personal',
  staffMembers: 'Personalmedlemmar',
  totalMembers: 'Totalt {n} medlemmar',
  emptyMessage: 'Inga personalmedlemmar hittades',
  cancel: 'Avbryt',
  inviteSubmit: 'Bjud in',
  emailLabel: 'E-post',
  emailPlaceholder: 'namn@foretag.se',
  phoneLabel: 'Telefon (valfritt)',
  phonePlaceholder: '070-123 45 67',
  roleLabel: 'Roll',
  inviteHint: 'En inbjudan skickas via e-post. Personen får tillgång när den accepteras.',
  inviteError: 'Inbjudan kunde inte skickas. Försök igen.',
  statusInvited: 'Inbjuden',
  removeTitle: 'Ta bort medlem',
  remove: 'Ta bort',
  confirmRemovePrefix: 'Är du säker på att du vill ta bort',
  confirmRemoveSuffix: 'från verkstaden?',
  removeAccessNote: 'Personen kommer inte längre att ha tillgång till dashboarden.',
}

export const en: typeof sv = {
  roleOwner: 'Owner',
  roleManager: 'Manager',
  roleMechanic: 'Mechanic',
  colName: 'Name',
  notProvided: 'Not provided',
  colRole: 'Role',
  colStatus: 'Status',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  colAdded: 'Added',
  heading: 'Staff',
  subtitle: 'Manage staff and permissions',
  carCareTitle: 'Car care account',
  carCareDescription: 'Staff management is not available for car care accounts. Switch to a garage in the side menu to manage staff.',
  switchToGarage: 'Switch to garage',
  subtitleCarCare: 'Manage the car care center’s staff and permissions',
  subtitleGarage: 'Manage the garage’s staff and permissions',
  invite: 'Invite staff',
  staffMembers: 'Staff members',
  totalMembers: '{n} members in total',
  emptyMessage: 'No staff members found',
  cancel: 'Cancel',
  inviteSubmit: 'Invite',
  emailLabel: 'Email',
  emailPlaceholder: 'name@company.com',
  phoneLabel: 'Phone (optional)',
  phonePlaceholder: '070-123 45 67',
  roleLabel: 'Role',
  inviteHint: 'An invitation is sent by email. The person gets access once they accept.',
  inviteError: 'The invitation could not be sent. Please try again.',
  statusInvited: 'Invited',
  removeTitle: 'Remove member',
  remove: 'Remove',
  confirmRemovePrefix: 'Are you sure you want to remove',
  confirmRemoveSuffix: 'from the garage?',
  removeAccessNote: 'The person will no longer have access to the dashboard.',
}
